import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { IaCApiFilter } from './IaCApiFilter';

export const IaCApiFilterFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'IaCApiFilter',
    component: IaCApiFilter,
  }),
);
